export default __webpack_public_path__ + "static/media/ChiomaOnyia.315f6251.svg";